// src/pages/UserDeepDivePage/SectionContainer.tsx
import { ReactNode } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Typography,
    IconButton,
} from '@mui/material'
import GetAppIcon from '@mui/icons-material/GetApp'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface SectionContainerProps {
    title: string
    onDownload?: () => void
    children: ReactNode
}

export default function SectionContainer({
    title,
    onDownload,
    children,
}: SectionContainerProps) {
    return (
        <Accordion
            disableGutters
            elevation={0}
            sx={{ width: '100%', bgcolor: 'transparent', padding: '16px' }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    px: 0,
                    py: 1,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    // pull the expand icon to the left
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        order: -1,
                        mr: 1,
                    },
                    '& .MuiAccordionSummary-content': {
                        alignItems: 'center',
                    },
                }}
            >
                <Box flex={1} display="flex" alignItems="center">
                    <Typography variant="h4">{title}</Typography>
                </Box>
                {onDownload && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation()
                            onDownload()
                        }}
                    >
                        <GetAppIcon fontSize="small" />
                    </IconButton>
                )}
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, py: 2 }}>
                {children}
            </AccordionDetails>
        </Accordion>
    )
}
